import { ProjectDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useMemo } from 'react';
import { useQueryListProjects } from '../../core/queries/projects.queries';

export function useProjectShortcodeMap() {
  const projects = useQueryListProjects();

  const uuids = useMemo(
    () =>
      (projects.data || []).reduce((acc, project: ProjectDto) => {
        const next = {
          [project.id]: project.id,
          ...acc
        };
        if (typeof project.shortcode !== 'undefined') {
          next[project.shortcode] = project.id;
        }
        return next;
      }, {} as Record<string, string | undefined>),
    [projects.data]
  );

  const shortcodes = useMemo(
    () =>
      (projects.data || []).reduce((acc, project: ProjectDto) => {
        const next = {
          [project.id]: project.shortcode,
          ...acc
        };
        if (typeof project.shortcode !== 'undefined') {
          next[project.shortcode] = project.shortcode;
        }
        return next;
      }, {} as Record<string, string | undefined>),
    [projects.data]
  );

  return [uuids, shortcodes, projects] as const;
}
